import { render } from "./SectionContainer.vue?vue&type=template&id=5231b7c3"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__